import React from 'react'
import Svg from '../../../../packages/uikit/src/components/Svg/Svg'
import { SvgProps } from '../../../../packages/uikit/src/components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => (
  <Svg width="22" height="16" viewBox="0 0 22 16" fill="none" {...props}>
    <g clipPath="url(#clip0_4509_580)">
      <path
        d="M14.5152 11.0988C13.6353 11.6082 12.8303 11.4546 12.0805 10.8135C11.3643 10.0267 10.7736 9.15208 10.391 8.14581C10.2808 7.85741 10.0666 7.71164 9.83242 7.5455C8.91269 6.89189 8.66172 5.39816 9.30446 4.4734C9.433 4.28844 9.44372 4.09252 9.46973 3.88562C9.80794 1.1944 10.9174 0.4107 13.2956 0.0439286C15.5635 -0.305601 17.3494 1.4734 17.4366 3.86054C17.4427 4.03766 17.3678 4.27434 17.5361 4.37308C18.1528 4.73202 18.1345 5.31195 18.0227 5.87778C17.8865 6.57371 17.6463 7.24926 16.9989 7.63327C16.8061 7.74769 16.6944 7.86681 16.6148 8.07371C16.1619 9.26023 15.4594 10.2681 14.5137 11.0988H14.5152Z"
        fill="white"
      />
      <path
        d="M10.6908 11.4513C12.1323 13.1974 14.2962 13.3745 15.9092 11.8337C16.301 11.4591 16.6483 11.3855 17.1396 11.5344C18.1863 11.851 19.253 12.1033 20.3012 12.4152C21.628 12.8118 22.3427 14.3604 21.8361 15.6676C21.7168 15.9764 21.4796 15.9952 21.2148 15.9952C16.0454 15.9952 10.8759 15.992 5.70649 15.9983C5.379 15.9983 5.1418 15.8917 5.09436 15.5532C4.88929 14.1174 4.96428 12.9356 6.59255 12.4387C7.14959 12.2695 7.69898 12.0751 8.25295 11.8933C9.08851 11.8776 9.83684 11.3572 10.6908 11.4482V11.4513Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21477 6.29304C6.60529 5.90252 6.60529 5.26935 6.21477 4.87883C5.82424 4.48831 5.19108 4.48831 4.80055 4.87883L2.67905 7.00034L1.70711 6.0284C1.31658 5.63787 0.683417 5.63787 0.292893 6.0284C-0.0976312 6.41892 -0.0976309 7.05209 0.292893 7.44261L1.97203 9.12174C2.36255 9.51227 2.99572 9.51227 3.38624 9.12174C3.38998 9.11801 3.39368 9.11425 3.39735 9.11046L6.21477 6.29304Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4509_580">
        <rect width="22" height="16" fill="white" />
      </clipPath>
    </defs>
  </Svg>
)

export default Icon
